import createEditManageWorkOrderStatus from '../modals/createEditManageWorkOrderStatus/lan/es';
import deleteManageWorkOrderStatus from '../modals/deleteManageWorkOrderStatus/lan/es';

export default {
    manage_workOrderStatus_name: "Nombre",
    manage_workOrderStatus_color: "Color",
    manage_workOrderStatus_description: "Descripción",
    manage_workOrderStatus_category: "Categoría",
    manage_workOrderStatus_default: "Predeterminado",
    manage_workOrderStatus_search_by_name_description: "Buscar por Nombre o Descripción",
    ...createEditManageWorkOrderStatus,
    ...deleteManageWorkOrderStatus,
}